import React from "react";
import TeteATete from "../TeteATete";

function Secret() {
  return <TeteATete />;
}

export default Secret;
